import React from "react";
import SearchInput from "../../../common/SearchInputField";

export default function ReviewQueueToolbar({
  searchQuery,
  setSearchQuery,
}) {
  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      marginTop: 16,

      marginBottom: '16px'
    }}>
      <div style={{ width: 280 }}>
        <SearchInput
          placeholder="Search articles"
          value={searchQuery}
          className='SearchInputField-article'
          onChange={(e) => setSearchQuery(e.target.value)}
          noTitle
        />
      </div>
    </div>
  );
}
